export default "__VITE_ASSET__e682ec6d__"